import { render, staticRenderFns } from "./HeadlineLogo.vue?vue&type=template&id=8d90065a&scoped=true&"
import script from "./HeadlineLogo.vue?vue&type=script&lang=js&"
export * from "./HeadlineLogo.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineLogo.vue?vue&type=style&index=0&id=8d90065a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d90065a",
  null
  
)

export default component.exports